<template>
  <input :value="value" @blur="$emit('blur')" @input="input">
</template>

<script>
export default {
  name: 'BaseInput',

  props: {
    value: {
      type: String,
      required: true
    }
  },

  methods: {
    input ($event) {
      this.$emit('input', $event.target.value)
    }
  }
}
</script>

<style lang="scss" scoped>
input {
  outline: none;
}
</style>
